/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useEffect } from 'react';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import { setIsProjectAdmin } from '../../common/utils.tsx';

const ProjectRouteListener = () => {
	const isSiteAdmin = useIsAdmin();
	const { data, loading } = useResource(projectContextResource);

	useEffect(() => {
		if (isSiteAdmin) {
			setIsProjectAdmin({ loading: false, isProjectAdmin: true });
		} else if (data != null) {
			setIsProjectAdmin({ loading: false, isProjectAdmin: data.isProjectAdmin });
		} else {
			setIsProjectAdmin({ loading, isProjectAdmin: null });
		}
	}, [data, loading, isSiteAdmin]);

	// Cleanup when component is unmounted. This means we are no longer in a project route
	useEffect(() => () => setIsProjectAdmin({ loading: false, isProjectAdmin: null }), []);

	return null;
};

export { ProjectRouteListener };
